import { nanoid } from "nanoid"

const CLIENT_ID_KEY = "LIQA:user_id"

export const getClientId = () => {
  const storedClientId = parent.localStorage.getItem(CLIENT_ID_KEY)

  if (storedClientId) return storedClientId

  const clientId = nanoid()
  parent.localStorage.setItem(CLIENT_ID_KEY, clientId)

  return clientId
}
